import dayjs, { Dayjs } from "utils/dayjs"

import { IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import Holiday, { IGetHolidayDto, RelativeHoliday } from "./Holiday"

export interface IGetRelativeHolidayDto {
    relativeHoliday: RelativeHoliday
    date: string
}

export interface IRelativeHoliday {
    relativeHoliday: RelativeHoliday
    date: Dayjs
}

export interface IGetHolidaysDto {
    entities: IGetHolidayDto[]
    relativeHolidays: IGetRelativeHolidayDto[]
    links: IApiLink[]
}

export default class Holidays {
    holidays: Holiday[]
    relativeHolidays: IRelativeHoliday[]
    linkCreateHoliday?: IApiLink

    constructor(dto: IGetHolidaysDto) {
        this.holidays = dto.entities.map(holiday => new Holiday(holiday))
        this.relativeHolidays = dto.relativeHolidays.map(rh => ({
            relativeHoliday: rh.relativeHoliday,
            date: dayjs.utc(rh.date, "YYYY-MM-DD"),
        }))
        this.linkCreateHoliday = dto.links.find(lnk => lnk.entity === ApiLinkEntity.holiday && lnk.rel === ApiLinkRel.new)
    }
}
